module.exports = __webpack_public_path__ + "img/dietitian-contact.9bc6fc63.png";